'use strict';

var RouteModuloBaseMixin = require("moduleFold/modulobase/scripts/mixins/RouteModuloBaseMixin");


/**
 * Registrazione delle route per il modulo bss/teststoragecommunications2
 *
 * @class
 * @param {type} $stateProvider
 * @param {type} $urlRouterProvider
 * @param {type} $locationProvider
 */

function Teststoragecommunications2Routes($stateProvider, $urlRouterProvider, $locationProvider){

  var self = {
        $stateProvider: $stateProvider,
        stato: "teststoragecommunications2",
        url: "/teststoragecommunications2",
        //templateUrl: "lib/teststoragecommunications2/scripts/templates/teststoragecommunications2.html",
        template: require("../templates/teststoragecommunications2.html"),
        controller: ["$http", "$q", "$timeout", "$state", "$stateParams", "DSFactory", "GridFactory", "ToolbarSrv", "identifica", "$scope", "ActionFactory", "ErrorManager", "Teststoragecommunications2FunzioniAggiuntive", require("../Teststoragecommunications2Ctrl")],
        //controllerAs
        //middleware
        //data
        //identifica
    };

    angular.extend(self, RouteModuloBaseMixin.prototype);
    self.registra();
}

module.exports = Teststoragecommunications2Routes;
